import React, { Component } from 'react'
import { connect } from 'react-redux'
import { PreviewComponent } from '../components'
import { updateRequestState, getRequestState } from '../../../shared/actions'

class Preview extends Component {


    goToScreen = (key, params) => {
        this.props.history.push({
            pathname: key,
            params: params,
        })
    }

    goBack = () => {
        this.props.history.replace("video")
    }

    submit = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((location) => {
                this.props.updateRequestState({
                    state: "user_submitted",
                    data: {
                        addressGeoPoint: {
                            latitude: location.coords.latitude,
                            longitude: location.coords.longitude
                        }
                    },
                    nextRoute: 'thankyou'
                })
            }, (err) => {
                alert(`${err.message}`)
            }, { enableHighAccuracy: true, maximumAge: 0 });
        } else {
            alert("Geo Location not supported by browser");
        }
    }

    render() {
        const { language, languageJSON, selfie, idPhoto, video, idProofFrontSide, idProofBackSide, addressProofBackSide, addressProofFrontSide, homeImage } = this.props
        return (
            <PreviewComponent
                goBack={this.goBack}
                goToScreen={this.goToScreen}
                language={language}
                languageJSON={languageJSON}
                selfie={selfie}
                idPhoto={idPhoto}
                video={video}
                homeImage={homeImage}
                idProofFrontSide={idProofFrontSide}
                idProofBackSide={idProofBackSide}
                addressProofFrontSide={addressProofFrontSide}
                addressProofBackSide={addressProofBackSide}
                submit={this.submit}
            />
        )
    }
}

const mapStateToProps = ({ selfie: { selfie }, idProof: { idProofFrontSide, idProofBackSide }, idPhoto: { idPhoto },
    addressProof: { addressProofFrontSide, addressProofBackSide }, video: { video }, homeImage: { homeImage }, language: { language, languageJSON } }) => ({
        language,
        selfie,
        idPhoto,
        idProofFrontSide,
        idProofBackSide,
        addressProofFrontSide,
        addressProofBackSide,
        homeImage,
        video,
        languageJSON
    })

const mapDispatchToProps = {
    updateRequestState,
    getRequestState
}

export default connect(mapStateToProps, mapDispatchToProps)(Preview)
